export default __webpack_public_path__ + "static/media/pic2.9f40c9cb.jpg";